import {
  Card,
  TextField,
  Grid,
  Typography,
  Tooltip,
  IconButton
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormHeaderGreeting from 'src/components/Greeting/FormHeaderGreeting';
import { RootState } from 'src/redux-store/appStore';
import { httpRequest } from 'src/services/httpRequest';
import EditFormfeatureViews from 'src/components/EditFormfeatureViews/EditFormfeatureViews';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import LoadingOverlay from 'src/components/common/LoadingOverlay';
import toast from 'react-hot-toast';
import { handleError } from 'src/redux-store/slices/errorSlice';
import InfoIcon from '@mui/icons-material/Info';
import Breadcrumb from 'src/ui-component/Breadcrumb';
import { Box, Container } from '@mui/system';
import FormikForm from 'src/ui-component/FormikFormLibrary';
import { Fields } from 'src/ui-component/FormikFormLibrary/FormikTypes';
import {
  PaymentApplicationDetails,
  PaymentSummary
} from 'src/types/RoadPermit/roadPermit.type';
import { getFeesForCurrentPermit } from '../common/getFeesForCurrentPermit';
import CustomButtonContained from 'src/components/CustomButton/CustomButtonContained';
import CustomModal from 'src/ui-component/customModal/CustomModal';
import { format } from 'date-fns';
import PdfGenerator from 'src/ui-component/PdfGenerator';
import { sendNotification } from 'src/utils/sendNotification';
import { getApplicationDetails } from '../common/getApplicationDetails';
import { DraftCheck } from 'src/types/PZPermit/pzPermit.type';
import { shouldShowEdit } from 'src/utils/CommonFunctions';

function EditApplicationTreePermit() {
  const dispatch = useDispatch();
  const currentPermitDetails = useSelector(
    (state: RootState) => state?.currentPermit?.currentPermitDetails
  );
  const socket = useSelector((store: RootState) => store.socket.socket);
  const userDetails = useSelector((store: RootState) => store.user.userDetails);
  const location = useLocation();
  const navigate = useNavigate();
  const messageBodyRef = useRef();
  const { applicationID, permit } = useParams();
  const basePath = `/${currentPermitDetails.townshipId}/${currentPermitDetails.departmentName}/${currentPermitDetails.id}`;
  const isManager = currentPermitDetails.currentPermitUserRole === 'Manager';
  const userData = useSelector((store: RootState) => store.user.userDetails);
  const [switchTo, setSwitchTo] = useState<string>('');
  const [openApprovePopup, setOpenApprovePopup] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false);
  const [IsOpen, setIsOpen] = useState<boolean>(false);
  const [feeDetails, setFeeDetails] = useState({
    applicationFee: 0,
    inspectionFee: 0
  });
  const [taxRate, setTaxRate] = useState<number>(0);
  const [clickedOn, setClickedOn] = useState<string>('');
  const [blockLotsOptions, setBlockLotsOptions] = useState<[]>();
  const [planningAndZoningFormData, setPlanningAndZoningFormData] = useState<{
    ApplicantName: string;
    ApplicationNumber: string;
    ApplicationStatus: string;
    ApplicationTitle: string;
    ApplicationType: string;
    Blocklots: string;
    PropertyAddress: string;
    ProjectContactName: string;
    ProjectContactPhone: string;
    ProjectContactAddress: string;
    CompanyName: string;
    EIN: string;
    DescribeUse: string;
    ApplicationFee: string;
    InspectionFee: string;
    ApprovedDate: string;
    RejectedDate: string;
    ReasonOfRejection: string;
    UserID: string;
  }>();

  // Method to get application details
  const handleGetApplicationDetails = async () => {
    const isDraft = location?.state && (location?.state as DraftCheck)?.isDraft
    const response = await getApplicationDetails({ applicationID, permit, isDraft })
    if (response?.status === "success") {
      setPlanningAndZoningFormData(response?.data?.data[0])
    }
  }

  // Method to get application details
  useEffect(() => {
    handleGetApplicationDetails()
  }, [applicationID, permit]);

  const PlanningAndZoningBottomSection = () => {
    return (
      <>
        <Box display={'flex'} gap={2}>
          <TextField
            id="outlined-basic"
            value={`$ ${planningAndZoningFormData?.ApplicationFee}`}
            disabled
            sx={{ mt: 2 }}
            label="Application Fee"
            variant="outlined"
            InputLabelProps={{
              className: 'weight-600'
            }}
          />
          <TextField
            id="outlined-basic"
            value={`$ ${planningAndZoningFormData?.InspectionFee}`}
            disabled
            sx={{ mt: 2 }}
            label="Inspection Fee"
            variant="outlined"
            InputLabelProps={{
              className: 'weight-600'
            }}
          />
        </Box>
        {planningAndZoningFormData?.ApplicationStatus !== "Draft" ?
          <Box mt={{ xs: 3 }}>
            <Grid item xs={12} sm={8} pt={4} display={{ sm: "flex", xs: "none" }}>
              <Grid item>
                <CustomButtonContained
                  onClick={() => setSwitchTo('Upload/View Document')}
                  title={'Upload/View Document'}
                />
                <CustomButtonContained
                  sx={{ ml: 2 }}
                  title={'View Message History'}
                  onClick={() => setSwitchTo('View Message History')}
                />
                <CustomButtonContained
                  sx={{ ml: 2 }}
                  title={'View Payment History'}
                  onClick={() => setSwitchTo('View Payment History')}
                />
                {isManager && !shouldShowEdit(planningAndZoningFormData) && (
                  <CustomButtonContained
                    sx={{ ml: 2 }}
                    onClick={() => setIsOpen(true)}
                    title={'Send Message'}
                  />
                )}
              </Grid>
            </Grid>
            <Box mt={{ xs: 3 }} display={{ sm: "none", xs: "flex" }} flexDirection={"column"}>
              <CustomButtonContained
                sx={{ mb: 1 }}
                onClick={() => setSwitchTo('Upload/View Document')}
                title={'Upload/View Document'}
              />
              <CustomButtonContained
                sx={{ mb: 1 }}
                title={'View Message History'}
                onClick={() => setSwitchTo('View Message History')}
              />
              <CustomButtonContained
                sx={{ mb: 1 }}
                title={'View Payment History'}
                onClick={() => setSwitchTo('View Payment History')}
              />
              {isManager && !shouldShowEdit(planningAndZoningFormData) && (
                <CustomButtonContained
                  onClick={() => setIsOpen(true)}
                  title={'Send Message'}
                />
              )}
            </Box>
          </Box>
          : null}
      </>
    );
  };

  // Method to handle message change
  const handleMessageChange = (e) => {
    messageBodyRef.current = e.target.value;
  };

  // Method to get block lots list
  const handleBlockLotsList = async (val) => {
    if (val) {
      if (val?.BlockLot) {
        setPlanningAndZoningFormData({
          ...planningAndZoningFormData,
          Blocklots: val?.BlockLot,
          PropertyAddress: val?.PropAddress
        });
      } else {
        if (val?.trim() === '') return;
        setPlanningAndZoningFormData({
          ...planningAndZoningFormData,
          Blocklots: val
        });
        if (val?.length > 2) {
          const response = await httpRequest(
            'GET',
            `/propertyDetails/searchBlockLots_Address?PropertyBlockLot=${val}`
          );
          if (response?.status === 'success') {
            const list = response?.data
              ?.map((value: { BlockLot: string }) => {
                return { ...value, label: value?.BlockLot };
              })
              ?.slice(0, 10);
            setBlockLotsOptions(list);
          } else if (response?.type === 'NETWORK_ERROR') {
          } else {
            toast.error(response?.message);
            dispatch(handleError(response?.message));
          }
        }
      }
    }
  };

  // Method to get application fee
  const handleGetApplicationFee = async () => {
    setLoading(true);
    const response = await httpRequest(
      'GET',
      `/configuration/fee_details?PermitID=${currentPermitDetails?.id}`
    );
    if (response?.status === 'success') {
      const feeObject = getFeesForCurrentPermit(response.data);
      setTaxRate(feeObject?.CreditCardFee || 0);
      setFeeDetails({
        applicationFee: Number(feeObject?.ApplicationFee),
        inspectionFee: Number(feeObject?.InspectionFee)
      });
      setLoading(false);
    } else if (response?.type === 'NETWORK_ERROR') {
    } else {
      setLoading(false);
      toast.error(response?.message);
      dispatch(handleError(response?.message));
    }
  };

  // Method to get application fee
  useEffect(() => {
    if (currentPermitDetails?.id) handleGetApplicationFee();
  }, [currentPermitDetails?.id]);

  // Method to get form buttons
  const getFormButtons = () => {
    let buttonsCollection = ['Cancel'];
    if (planningAndZoningFormData?.ApplicationStatus) {
      if (
        planningAndZoningFormData?.ApplicationStatus === 'In Review' ||
        planningAndZoningFormData?.ApplicationStatus === 'Draft'
      ) {
        buttonsCollection = [...buttonsCollection, 'Update'];
      }
      if (planningAndZoningFormData?.ApplicationStatus === 'Draft') {
        buttonsCollection = [...buttonsCollection, 'Proceed to Payment'];
      }
      if (
        isManager &&
        planningAndZoningFormData?.ApplicationStatus === 'In Review'
      ) {
        buttonsCollection = [...buttonsCollection, 'Approve'];
      }
    }
    return buttonsCollection;
  };

  // Method to handle proceed to pay
  const handleProceedToPay = async () => {
    const paymentSummary: PaymentSummary = {
      fees: Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(feeDetails).filter(([_, value]) => value > 0)
      ),
      ...(taxRate > 0 ? { taxRate } : {})
    };
    const paymentApplicationDetails: PaymentApplicationDetails = {
      applicationDetails: {
        userName: `${userData?.FirstName} ${userData?.LastName}`,
        applicationNumber: null,
        applicationId: applicationID,
        applicationStatus: 'Draft',
        statusPayload: 'In Review',
        permitPrefix:
          planningAndZoningFormData?.ApplicationType === 'Planning' ? 'P' : 'Z'
      }
    };
    navigate(
      `/payment-methods`,
      { state: { paymentSummary, paymentApplicationDetails } }
    );
  };

  // Method to update application details
  const handleUpdate = async (data, type = '') => {
    const requestData = { ...planningAndZoningFormData, ...data };
    setPlanningAndZoningFormData({ ...requestData });
    setLoading(true);
    const payload = {
      ApplicantName: requestData?.ApplicantName,
      ApplicationType: requestData?.ApplicationType,
      ApplicationTitle: requestData?.ApplicationTitle,
      Blocklots: requestData?.Blocklots,
      PropertyAddress: requestData?.PropertyAddress,
      ProjectContactName: requestData?.ProjectContactName,
      ProjectContactPhone: requestData?.ProjectContactPhone,
      ProjectContactAddress: requestData?.ProjectContactAddress,
      CompanyName: requestData?.CompanyName,
      EIN: requestData?.EIN,
      DescribeUse: requestData?.DescribeUse
    };
    const response = await httpRequest(
      'PUT',
      `/pz_application/update/${applicationID}`,
      payload
    );
    if (type === 'Approve') {
      setLoading(false);
      return response?.status === 'success';
    }
    else {
      if (response?.status === 'success') {
        setLoading(false);
        if (type === '') toast?.success('Application updated successfully.');
        navigate(
          `${basePath}/${planningAndZoningFormData?.ApplicationStatus === 'Draft'
            ? 'draft-application'
            : 'application-list'
          }`
        );
      } else {
        toast?.error(response?.message);
        setLoading(false);
        dispatch(handleError(response?.message));
      }
      return response?.status === 'success';
    }
  };

  // Method to approve application
  const handleApproveApplication = async () => {
    ('in aprv func-------------')
    setOpenApprovePopup(false)
    setLoading(true);
    const payload = {
      ApplicationID: Number(applicationID),
      ApplicationStatus: 'Approved',
      Address: planningAndZoningFormData?.PropertyAddress
    };
    const response = await httpRequest(
      'PUT',
      `/applications/${currentPermitDetails?.id}/update_status`,
      payload
    );
    if (response?.status === 'success') {
      sendNotification(socket, {
        UserID: planningAndZoningFormData?.UserID, // receiver user ID
        TownshipID: currentPermitDetails.townshipId,
        ApplicationID: applicationID,
        PermitID: permit,
        Title: 'Application Approved',
        Message: `${planningAndZoningFormData.ApplicationType} application with the no. ${planningAndZoningFormData?.ApplicationNumber} is approved successfully.`,
        ApplicationNumber: planningAndZoningFormData?.ApplicationNumber
      });
      toast?.success(`Application Approved successfully.`);
      navigate(`${basePath}/application-list`);
    } else {
      toast?.error(response?.message);
      dispatch(handleError(response?.message));
    }
    setLoading(false);
  };

  // Method to handle update and payment
  const handleUpdateAndPayment = async (data) => {
    if (clickedOn === 'Update') {
      handleUpdate(data);
    } else if (clickedOn === 'Proceed to Payment') {
      const applicationUpdated = await handleUpdate(data, 'Proceed to Payment');
      if (applicationUpdated) handleProceedToPay();
    } else if (clickedOn === 'Approve') {
      const applicationUpdated = await handleUpdate(data, 'Approve');
      if (applicationUpdated) setOpenApprovePopup(true);
    }
  };

  //Method to handle block lot change
  const handleChange = (val, e) => {
    const { name } = e;
    if (name === 'BlockLot') {
      handleBlockLotsList(val);
    } else
      setPlanningAndZoningFormData({
        ...planningAndZoningFormData,
        [name]: val
      });
  };

  //form fields using formik
  const allFields: Fields[] = [
    {
      fieldName: 'ApplicationType',
      fieldLabel: 'Application Type',
      fieldType: 'select',
      required: true,
      options: ['Planning', 'Zoning'],
      initialValue: planningAndZoningFormData?.ApplicationType || '',
      disabled: true,
      dependency: handleChange
    },
    {
      fieldName: 'ApplicationTitle',
      fieldLabel: 'Application Title',
      fieldType: 'text',
      required: true,
      initialValue: planningAndZoningFormData?.ApplicationTitle || '',
      disabled: !isManager,
      dependency: handleChange
    },
    {
      fieldName: 'ApplicantName',
      fieldLabel: 'Applicant Name',
      fieldType: 'text',
      required: true,
      initialValue: planningAndZoningFormData?.ApplicantName || '',
      disabled: !isManager,
      dependency: handleChange
    },
    {
      fieldName: 'CompanyName',
      fieldLabel: 'Company Name',
      fieldType: 'text',
      required: true,
      initialValue: planningAndZoningFormData?.CompanyName || '',
      dependency: handleChange
    },
    {
      fieldName: 'ProjectContactName',
      fieldLabel: 'Project Contact Name',
      fieldType: 'text',
      required: true,
      initialValue: planningAndZoningFormData?.ProjectContactName || '',
      dependency: handleChange
    },
    {
      fieldName: 'ProjectContactPhone',
      fieldLabel: 'Project Contact Phone',
      fieldType: 'mobile',
      required: true,
      initialValue: planningAndZoningFormData?.ProjectContactPhone || '',
      dependency: handleChange
    },
    {
      fieldName: 'BlockLot',
      fieldLabel: 'Block Lot',
      fieldType: 'autocomplete',
      placeHolder: 'Enter minimum 3 digits',
      required: true,
      initialValue: planningAndZoningFormData?.Blocklots,
      // disabled: !isManager,
      options: blockLotsOptions || [
        {
          label: planningAndZoningFormData?.Blocklots,
          BlockLot: planningAndZoningFormData?.Blocklots,
          PropertyAddress: planningAndZoningFormData?.PropertyAddress
        }
      ],
      disabled: !isManager,
      dependency: handleChange
    },
    {
      fieldName: 'ProjectLocation/PropertyAddress',
      fieldLabel: 'Project Location/Property Address',
      fieldType: 'text',
      disabled: true,
      required: false,
      initialValue: planningAndZoningFormData?.PropertyAddress || '',
      dependency: handleChange
    },
    {
      fieldName: 'ProjectContactAddress',
      fieldLabel: 'Project Contact Address',
      fieldType: 'note',
      required: true,
      initialValue: planningAndZoningFormData?.ProjectContactAddress || '',
      dependency: handleChange
    },
    {
      fieldName: 'DescribeUse',
      fieldLabel: 'Describe Use',
      fieldType: 'note',
      required: true,
      initialValue: planningAndZoningFormData?.DescribeUse || '',
      disabled: !isManager,
      dependency: handleChange
    },
    {
      fieldName: 'EIN',
      fieldLabel: 'EIN',
      fieldType: 'number',
      required: true,
      initialValue: planningAndZoningFormData?.EIN || '',
      dependency: handleChange
    }
  ];

  //Method to UPDATE application status
  const handleApplicationStatusMsg = () => {
    let msg = '';
    if (planningAndZoningFormData?.ApplicationStatus === 'Approved') {
      msg = `This application has been successfully approved ${planningAndZoningFormData?.ApprovedDate &&
        ` on ${format(
          new Date(planningAndZoningFormData?.ApprovedDate),
          'MM/dd/yyyy'
        )}`
        }.`;
    } else if (planningAndZoningFormData?.ApplicationStatus === 'Rejected') {
      msg = `This application has been rejected${planningAndZoningFormData?.RejectedDate &&
        ` on ${format(
          new Date(planningAndZoningFormData?.RejectedDate),
          'MM/dd/yyyy'
        )}`
        }.`;
    }
    return msg;
  };

  return loading ? (
    <LoadingOverlay />
  ) : (
    <Container sx={{ mt: 2 }} className="main-table-container">
      <Breadcrumb
        PermitName={'Planning and Zoning'}
        PageTitle={'Edit Application'}
      />
      <FormHeaderGreeting
        name={`${userData?.FirstName} ${userData?.LastName}`}
        applicationType="edit"
        applicationStatus={planningAndZoningFormData?.ApplicationStatus}
        applicationNumber={planningAndZoningFormData?.ApplicationNumber}
      />

      {switchTo !== '' ? (
        <EditFormfeatureViews
          switchTo={switchTo}
          setSwitchTo={setSwitchTo}
          applicationDetails={{
            applicationID: applicationID,
            TownshipID: currentPermitDetails?.townshipId,
            UserID: userDetails?.UserID,
            ApplicationStatus: planningAndZoningFormData?.ApplicationStatus
          }}
        />
      ) : (
        <Card>
          <Box m={{ md: 3, xs: 1 }}>
            <Box mb={2} display={'flex'} alignItems={'center'}>
              <Typography
                color={
                  planningAndZoningFormData?.ApplicationStatus === 'Approved'
                    ? 'green'
                    : '#8B0000'
                }
                fontSize={15}
                fontWeight={500}
              >
                {handleApplicationStatusMsg()}
              </Typography>
              {planningAndZoningFormData?.ApplicationStatus === 'Rejected' &&
                planningAndZoningFormData?.ReasonOfRejection ? (
                <Tooltip
                  title={
                    'Reason of rejection -' +
                    ' ' +
                    planningAndZoningFormData?.ReasonOfRejection
                  }
                  arrow
                >
                  <IconButton>
                    <InfoIcon color="primary" fontSize="small" />
                  </IconButton>
                </Tooltip>
              ) : null}

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  flex: 1
                }}
              >
                <PdfGenerator
                  PermitName={'Planning and Zoning'}
                  allFields={allFields}
                />
              </Box>
            </Box>
            <FormikForm
              allFields={allFields}
              buttonTitle={getFormButtons()}
              fullScreen={false}
              isEditModel={false}
              content={PlanningAndZoningBottomSection}
              setClickedOn={setClickedOn}
              clickProp
              defaultEnabledButton={['Proceed to Payment', 'Approve']}
              formMethod={handleUpdateAndPayment}
              buttonPlacement={'right'}
              handleOtherButton={() => {
                navigate(
                  `${basePath}/${planningAndZoningFormData?.ApplicationStatus === 'Draft'
                    ? 'draft-application'
                    : 'application-list'
                  }`
                );
              }}
            />
          </Box>
        </Card>
      )}
      <CustomModal
        title={'Send Message'}
        IsOpen={IsOpen}
        setIsOpen={setIsOpen}
        actionButtons={['Cancel', 'Send']}
        loading={loading}
        messageBodyRef={messageBodyRef}
        setLoading={setLoading}
        applicationNumber={planningAndZoningFormData?.ApplicationNumber}
        applicationDetails={planningAndZoningFormData}
        content={
          <TextField
            className="txtArea"
            label="Message"
            placeholder="Message"
            name="message"
            multiline
            onChange={(e) => handleMessageChange(e)}
            sx={{ width: '600px' }}
            rows={3}
          />
        }
      />
      <CustomModal
        title={'Approve Application?'}
        IsOpen={openApprovePopup}
        setIsOpen={setOpenApprovePopup}
        onSave={handleApproveApplication}
        actionButtons={['No', 'Yes']}
        loading={loading}
        content={
          <Typography>Are you sure you want to approve this application?</Typography>
        }
      />
    </Container>
  );
}

export default EditApplicationTreePermit;
